import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mlb/react-patterns/v4/components/Button/button';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import { ATBAT_MODAL_BREAKPOINT } from '@gameday/components/themes/breakpoints';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import useTracking from '@gameday/utils/hooks/useTracking';
import styled from 'styled-components';
import { useAccessToken } from '@gameday/utils/hooks/usePermissionToTrack';
import { useDispatch } from 'react-redux';
import authReady from '@gameday/core/actions/authReady';
import { HighlightPlay } from '../../VideoPlayer/VideoPlayer.style';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const buttonTextLoggedIn = 'Click to view Gameday 3D';
const buttonTextLoggedOut = 'Log in to view Gameday 3D';
const dictKeyLoggedIn = 'fieldvision_fvod_launch_button';
const dictKeyLoggedOut = 'fieldvision_fvod_login_button';

const {
    mlbBlack
} = COLORS;

const LoginWrapper = styled.div`
    ${({ $venueId }) => {
        const venueId = $venueId;
        return `
            background-image: var(--gameday-video-highlight-gradient), url('https://storage.googleapis.com/mlb-bdata-prod-us-east4-field-vision-builds/images/stadium-logins/${venueId}.jpg');
        `;
    }};
    background-size: cover;
    position: relative;
    width: 100%;
    height: 96%;
    min-height: 185px;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        margin-top: var(--gameday-section-padding-sm);
        height: 185px;
    }
`;

export const LoginInnerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 40px;
    margin: 0 0 8px 8px;
`;

const EngageWith3D = styled(Button)`
${({ isLoggedIn }) => {
    if (isLoggedIn) {
        return `
            background-color: rgba(0, 0, 0, 0) !important;
            height: auto;
        `;
    } else {
        return `
            width: 98%;
        `;
    }
}};
    border-radius: 20px;
    font-size: 18px;
    height: 100%;
`;

const FieldVisionLoginButton = (props) => {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const { venueId, isLoggedIn, setIsOptedIn, onAuthOpen } = props;
    const accessToken = useAccessToken();
    const Tracking = useTracking();
    let trackingVerb = 'Clicked';
    const handlers = {
        onClick: () => {
            if (!isLoggedIn) {
                if (onAuthOpen) {
                    onAuthOpen();
                }
                trackingVerb = 'Logged';
            }
            setIsOptedIn(true);
            Tracking.track.track_click({
                componentName: ['Gameday 3D Replay'],
                text: 'AtBatDetail',
                activity: `${trackingVerb} into At Bat Detail`
            });
        }
    };

    useEffect(() => {
        if (!accessToken) {
            dispatch(authReady);
        }
    }, [accessToken]);

    const playButton = isLoggedIn ? <HighlightPlay><Icon name='play' fill={ mlbBlack } width='20' /></HighlightPlay> : null;
    const buttonText = isLoggedIn ? translate(dictKeyLoggedIn, buttonTextLoggedIn) : translate(dictKeyLoggedOut, buttonTextLoggedOut);
    return (
        <LoginWrapper $venueId={venueId}>
            <LoginInnerWrapper onClick={handlers.onClick}>
                {playButton}
                <EngageWith3D isLoggedIn={isLoggedIn} label={buttonText} />
            </LoginInnerWrapper>
        </LoginWrapper>
    );
};

FieldVisionLoginButton.propTypes = {
    isLoggedIn: PropTypes.bool,
    onAuthOpen: PropTypes.func,
    setIsOptedIn: PropTypes.func
};

export default FieldVisionLoginButton;
